import { createSlice } from '@reduxjs/toolkit';
import { ThunkGetOneClickEuvMethods } from 'store/oneClickEuvMethods/thunks';
import { getRequestKey } from 'store/oneClickEuvMethods/helpers';
import { IOneClickEuvMethod } from 'services/pod/types';
import { RootState } from 'store/index';

interface IState {
  methods: IOneClickEuvMethod[];
  requestedKey?: string;
}

const initialState: IState = {
  methods: [],
};

const oneClickEuvMethodsSlice = createSlice({
  name: 'oneClickEuvMethods',
  reducers: {},
  initialState,
  extraReducers: builder => {
    builder.addCase(ThunkGetOneClickEuvMethods.pending, (state, action) => {
      state.requestedKey = getRequestKey(action.meta.arg);
    });
    builder.addCase(ThunkGetOneClickEuvMethods.fulfilled, (state, action) => {
      state.methods = action.payload ?? [];
    });
    builder.addCase(ThunkGetOneClickEuvMethods.rejected, state => {
      state.methods = [];
      state.requestedKey = undefined;
    });
  },
});

export default oneClickEuvMethodsSlice.reducer;

export const OneClickEuvMethodsSelector = (state: RootState): IOneClickEuvMethod[] =>
  state.oneClickEuvMethods.methods;
